import React from 'react';
import ReactDOM from 'react-dom';
// import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './app/shared/store';
import { Router } from 'react-router-dom';

import { history } from './app/shared/helpers/history';
import { globalActions } from './app/shared/actions/global.actions';

store.dispatch(globalActions.fetchStateFromStorage());

ReactDOM.render(
    <Router history={history}>
        <Provider store={store}>
            <App />
        </Provider>
    </Router>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
